// extracted by mini-css-extract-plugin
export default {"select":"Select__select___T5NYs"};